import { contextForSession } from '../discovery/context-query.js';
/** The warmup and actual entry share the same one-use, owner-scoped session. */
export function fundingSessionQuery(client, cache, navigationKey = 0) {
    return {
        queryKey: ['onramp', client.cacheKey, 'session', navigationKey],
        queryFn: async ({ signal }) => {
            await contextForSession(cache, client, signal, navigationKey);
            return client.createSession(signal);
        },
        networkMode: 'always',
        retry: false,
        gcTime: Infinity,
        staleTime: Infinity,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        meta: { persist: false },
    };
}
